import { Link } from "react-router-dom";
import { copy } from "../copy";

// The one calm section on the page.
export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works"
      className="border-t border-ground-edge px-4 py-20 md:px-6 md:py-28"
    >
      <div className="mx-auto w-full max-w-6xl">
        <p className="text-[11px] uppercase tracking-[0.24em] text-chrome-dim">{copy.how.eyebrow}</p>
        <h2 className="mt-3 max-w-3xl font-headline text-4xl uppercase leading-[0.95] tracking-[-0.01em] text-chrome md:text-6xl">
          {copy.how.heading}
        </h2>
        <ol className="mt-12 grid grid-cols-1 gap-10 md:mt-16 md:grid-cols-3 md:gap-8">
          {copy.how.steps.map((step, i) => (
            <li key={step.title} data-testid="how-step" className="border-t border-ground-edge pt-6">
              <p className="bf-tabular font-headline text-5xl leading-none text-gold">{String(i + 1).padStart(2, "0")}</p>
              <h3 className="mt-5 font-headline text-2xl uppercase tracking-[0.01em] text-chrome">{step.title}</h3>
              <p className="mt-3 max-w-sm text-sm leading-relaxed text-chrome-dim">{step.body}</p>
            </li>
          ))}
        </ol>
        <Link
          to="/how-it-works"
          className="bf-focusable mt-12 inline-block text-xs font-bold uppercase tracking-[0.16em] text-gold transition-colors hover:text-gold-light"
        >
          {copy.how.more} →
        </Link>
      </div>
    </section>
  );
}
